var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input',{staticClass:"fixed-decimal-number-input",attrs:{"id":_vm.id,"type":"number","number":"","min":"0","step":_vm.step},on:{"input":_vm.handle_input},model:{value:(_vm.current_value),callback:function ($$v) {_vm.current_value=$$v},expression:"current_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }